import React from 'react';
import { RequireAuth } from '../../auth/RequiredAuth';
import { useQueryTestTypeStatisticsQuery } from '../results/resultsApi';
import { useAccessToken } from '../../auth/app-authenticator.hook';
import { TestType } from '../subject/types';
import {
  Box,
  MenuItem,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { TestStatus } from '../../API';

function TestMonitoringTable() {
  const accessToken = useAccessToken();
  const [testStatusFilter, setTestStatusFilter] = React.useState<TestStatus>();
  const { data: testTypeStatistics } = useQueryTestTypeStatisticsQuery(
    { testType: TestType.IAT, accessToken: accessToken! },
    { skip: !accessToken },
  );
  if (!testTypeStatistics) {
    return <></>;
  }
  const filteredTestTypeStatistics = testStatusFilter
    ? testTypeStatistics.filter((test) => test.test.status === testStatusFilter)
    : testTypeStatistics;
  return (
    <Stack spacing={1}>
      <Box
        sx={{
          padding: '1em',
          flex: 1,
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          gap: '1em',
        }}
      >
        <Select
          placeholder={'Test Status'}
          label={'Test Status'}
          value={testStatusFilter}
          sx={{ flex: 1 }}
          onChange={(e) => setTestStatusFilter(e.target.value as TestStatus)}
        >
          {Object.values(TestStatus).map((status) => (
            <MenuItem key={status} value={status}>
              {status}
            </MenuItem>
          ))}
        </Select>
      </Box>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Test ID</TableCell>
            <TableCell>Test Name</TableCell>
            <TableCell>Updated At</TableCell>
            <TableCell>Test Status</TableCell>
            <TableCell>Test Result Status</TableCell>
            <TableCell>Test Result Stats</TableCell>
            <TableCell>Test Result Finished Percentage</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredTestTypeStatistics.map((test) => {
            return (
              <TableRow key={test.test.id}>
                <TableCell>{test.test.id}</TableCell>
                <TableCell>
                  <a href={`/tests/IAT/${test.test.id}`} target="_blank">
                    {test.test.name}
                  </a>
                </TableCell>
                <TableCell>{(test.test as any).updatedAt}</TableCell>
                <TableCell>{test.test.status}</TableCell>
                <TableCell>{test.status.status}</TableCell>
                <TableCell>
                  {test.status.testStatusEntry?.statistics && (
                    <>{`${test.status.testStatusEntry.statistics.finishedProbandAmount} / ${test.status.testStatusEntry.statistics.processedProbandAmount}`}</>
                  )}
                </TableCell>
                <TableCell>
                  {test.stats?.percentage
                    ? `${Math.round(test.stats.percentage)}%`
                    : 'N/A'}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Stack>
  );
}

export function TestMonitoringPage() {
  return (
    <RequireAuth>
      <Paper>
        <TestMonitoringTable />
      </Paper>
    </RequireAuth>
  );
}
